import React from "react";
import AcademicInfo from "./AcademicInfo";
import AcademicVerificationInfo from "./AcademicVerificationInfo";
import AthleticInfo from "./AthleticInfo";
import AwardsInfo from "./AwardsInfo";
import CalenderIntegration from "./CalenderIntegration";
import CoachInfo from "./CoachInfo";
import ExtrasInfo from "./ExtrasInfo";
import HobbyInfo from "./HobbyInfo";
import HonorsInfo from "./HonorsInfo";
import ImagesInfo from "./ImagesInfo";
import PersonalInfo from "./PersonalInfo";
import Schedule from "./Schedule";
import SocialInfo from "./SocialInfo";
import StrengthsInfo from "./StrengthsInfo";
import VideosInfo from "./VideosInfo";

const InfoContainer = (props) => {
  return (
    <div className="update-profile-info">
      {(props.data?.uncommonNewData?.imageOne ||
        props.data?.uncommonNewData?.imageTwo ||
        props.data?.uncommonNewData?.imageThree ||
        props.data?.uncommonNewData?.imageFour ||
        props.data?.uncommonNewData?.imageFive) && (
        <ImagesInfo data={props.data} />
      )}
      {(props.data?.uncommonNewData?.videoOne ||
        props.data?.uncommonNewData?.videoOneTitle ||
        props.data?.uncommonNewData?.videoTwo ||
        props.data?.uncommonNewData?.videoTwoTitle ||
        props.data?.uncommonNewData?.videoThree ||
        props.data?.uncommonNewData?.videoThreeTitle ||
        props.data?.uncommonNewData?.videoFour ||
        props.data?.uncommonNewData?.videoFourTitle) && (
        <VideosInfo data={props.data} />
      )}

      {(props.data?.uncommonNewData?.firstName ||
        props.data?.uncommonNewData?.lastName ||
        props.data?.uncommonNewData?.hometown ||
        props.data?.uncommonNewData?.class ||
        Object.keys(props.data?.uncommonNewData).includes("committed") ||
        props.data?.uncommonNewData?.committedSchool ||
        props.data?.uncommonNewData?.parentOneFirstName ||
        props.data?.uncommonNewData?.parentOneLastName ||
        props.data?.uncommonNewData?.parentTwoFirstName ||
        props.data?.uncommonNewData?.parentTwoLastName) && (
        <PersonalInfo data={props.data} />
      )}

      {(props.data?.uncommonNewData?.sport ||
        props.data?.uncommonNewData?.primaryPosition ||
        props.data?.uncommonNewData?.secondaryPosition ||
        props.data?.uncommonNewData?.bats ||
        props.data?.uncommonNewData?.throws ||
        props.data?.uncommonNewData?.specialtyMetrics ||
        props.data?.uncommonNewData?.clubName ||
        props.data?.uncommonNewData?.clubTeamName ||
        props.data?.uncommonNewData?.jersey ||
        props.data?.uncommonNewData?.height ||
        props.data?.uncommonNewData?.weight ||
        props.data?.uncommonNewData?.ncaaId) && (
        <AthleticInfo data={props.data} />
      )}
      {(props.data?.uncommonNewData?.imageHighSchoolOne ||
        props.data?.uncommonNewData?.imageHighSchoolTwo ||
        props.data?.uncommonNewData?.imageHighSchoolThree ||
        props.data?.uncommonNewData?.imageHighSchoolFour ||
        props.data?.uncommonNewData?.imageHighSchoolFive) && (
        <Schedule data={props.data} />
      )}
      {(props.data?.uncommonNewData?.gpa ||
        props.data?.uncommonNewData?.act ||
        props.data?.uncommonNewData?.sat ||
        props.data?.uncommonNewData?.classRank ||
        props.data?.uncommonNewData?.highSchoolName ||
        props.data?.uncommonNewData?.highSchoolCityState ||
        props.data?.uncommonNewData?.intendedMajor) && (
        <AcademicInfo data={props.data} />
      )}
      {(props.data?.uncommonNewData?.transcriptImage ||
        props.data?.uncommonNewData?.actScoreImage ||
        props.data?.uncommonNewData?.satScoreImage) && (
        <AcademicVerificationInfo data={props.data} />
      )}
      <CalenderIntegration data={props.data} />
      {(props.data?.uncommonNewData?.clubCoachName ||
        props.data?.uncommonNewData?.clubCoachPhone ||
        props.data?.uncommonNewData?.clubCoachEmail ||
        props.data?.uncommonNewData?.highSchoolCoachName ||
        props.data?.uncommonNewData?.highSchoolCoachPhone ||
        props.data?.uncommonNewData?.highSchoolCoachEmail ||
        props.data?.uncommonNewData?.hittingCoachName ||
        props.data?.uncommonNewData?.hittingCoachPhone ||
        props.data?.uncommonNewData?.hittingCoachEmail ||
        props.data?.uncommonNewData?.pitchingCoachName ||
        props.data?.uncommonNewData?.pitchingCoachPhone ||
        props.data?.uncommonNewData?.pitchingCoachEmail ||
        props.data?.uncommonNewData?.catchingCoachName ||
        props.data?.uncommonNewData?.catchingCoachPhone ||
        props.data?.uncommonNewData?.catchingCoachEmail ||
        props.data?.uncommonNewData?.specialtyCoachName ||
        props.data?.uncommonNewData?.specialtyCoachFocus ||
        props.data?.uncommonNewData?.specialtyCoachPhone ||
        props.data?.uncommonNewData?.specialtyCoachEmail) && (
        <CoachInfo data={props.data} />
      )}
      {(props.data?.uncommonNewData?.youTube ||
        props.data?.uncommonNewData?.twitter ||
        props.data?.uncommonNewData?.instagram ||
        props.data?.uncommonNewData?.facebook ||
        props.data?.uncommonNewData?.hudl ||
        props.data?.uncommonNewData?.agl) && <SocialInfo data={props.data} />}
      {(props.data?.uncommonNewData?.academicHonorOne ||
        props.data?.uncommonNewData?.academicHonorTwo ||
        props.data?.uncommonNewData?.academicHonorThree ||
        props.data?.uncommonNewData?.academicHonorFour ||
        props.data?.uncommonNewData?.academicHonorFive ||
        props.data?.uncommonNewData?.academicHonorSix ||
        props.data?.uncommonNewData?.academicHonorSeven ||
        props.data?.uncommonNewData?.academicHonorEight ||
        props.data?.uncommonNewData?.academicHonorNine ||
        props.data?.uncommonNewData?.academicHonorTen) && (
        <HonorsInfo data={props.data} />
      )}
      {(props.data?.uncommonNewData?.athleticAwardOne ||
        props.data?.uncommonNewData?.athleticAwardTwo ||
        props.data?.uncommonNewData?.athleticAwardThree ||
        props.data?.uncommonNewData?.athleticAwardFour ||
        props.data?.uncommonNewData?.athleticAwardFive ||
        props.data?.uncommonNewData?.athleticAwardSix ||
        props.data?.uncommonNewData?.athleticAwardSeven ||
        props.data?.uncommonNewData?.athleticAwardEight ||
        props.data?.uncommonNewData?.athleticAwardNine ||
        props.data?.uncommonNewData?.athleticAwardTen) && (
        <AwardsInfo data={props.data} />
      )}
      {(props.data?.uncommonNewData?.strengthOne ||
        props.data?.uncommonNewData?.strengthTwo ||
        props.data?.uncommonNewData?.strengthThree ||
        props.data?.uncommonNewData?.strengthFour ||
        props.data?.uncommonNewData?.strengthFive) && (
        <StrengthsInfo data={props.data} />
      )}
      {(props.data?.uncommonNewData?.extraOne ||
        props.data?.uncommonNewData?.extraTwo ||
        props.data?.uncommonNewData?.extraThree ||
        props.data?.uncommonNewData?.extraFour ||
        props.data?.uncommonNewData?.extraFive) && (
        <ExtrasInfo data={props.data} />
      )}

      {(props.data?.uncommonNewData?.hobbyOne ||
        props.data?.uncommonNewData?.hobbyTwo ||
        props.data?.uncommonNewData?.hobbyThree ||
        props.data?.uncommonNewData?.hobbyFour ||
        props.data?.uncommonNewData?.hobbyFive) && (
        <HobbyInfo data={props.data} />
      )}
    </div>
  );
};

export default InfoContainer;
